<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']" >
    <div class="content">
<!-- Header Card -->
<div class="header-card">
  <div class="truck-icon">🚛</div>
  <div class="truck-info">
    <h1><a class="back-arrow" (click)="goBack()"><svg viewBox="0 0 24 24" width="20" height="20" stroke="#212B36" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line _ngcontent-ng-c1832648="" x1="19" y1="12" x2="5" y2="12"></line><polyline _ngcontent-ng-c1832648="" points="12 19 5 12 12 5"></polyline></svg></a> 
        {{truckDetails?.truckNumber}}</h1>
    <div class="truck-meta">
      <span class="tag">{{truckDetails?.truckModel}}</span>
      <span class="tag">{{truckDetails?.truckSize}}</span>
      <span class="tag">Assembled: {{truckDetails?.createdAt | CustomDatePipe: 'D-M-YYYY'}}</span>
      <span class="tag">Vendor: {{truckDetails?.vendorName}}</span>
    </div>
  </div>
  <div class="stats">
    <div class="stat" >
      <div class="stat-value">{{truckDetails?.component?.length ? truckDetails?.component?.length : '0'}}</div>
      <!-- <div class="stat-value">{{statusCount.Live ? statusCount.Live : '0'}}</div> -->
      <div class="stat-label">Live Components</div>
    </div>
    <div class="stat">
      <div class="stat-value">{{statusCount.Past ? statusCount.Past : '0'}}</div>
      <div class="stat-label">Past Components</div>
    </div>
    <div class="stat">
      <div class="stat-value black">{{totalElements ? totalElements : '0'}}</div>
      <div class="stat-label">Total Records</div>
    </div>
    <div class="stat">
      <div class="stat-value black">{{truckDetails?.initialKmTravelled}}<span class="stat-km">km</span></div>
      <div class="stat-label">Current KM</div>
    </div>
  </div>
</div>

<!-- Filter Bar -->
<!-- <div class="filter-bar">
  <button class="filter-btn active">
    <span class="dot"></span> All Types <span class="count">8</span>
  </button>
  <button class="filter-btn">
    <span class="filter-icon">⬤</span> Tyre <span class="count">3</span>
  </button>
  <button class="filter-btn">
    <span class="filter-icon">⚡</span> Battery <span class="count">2</span>
  </button>
  <button class="filter-btn">
    <span class="filter-icon">🛡</span> Insurance <span class="count">1</span>
  </button>
  <button class="filter-btn">
    <span class="filter-icon">🌿</span> Pollution <span class="count">1</span>
  </button>
  <button class="filter-btn">
    <span class="filter-icon">🔧</span> Repair &amp; Maint. <span class="count">1</span>
  </button>
</div> -->

<!-- Action Bar -->
<div class="action-bar">
  <div class="status-filter">
    <div class="">
        <label class="field-label"><span class="required-dot"></span> Component Filter</label>
        <div class="">
        <ng-select  (change)="onChangeComponent($event)"  appendTo="body" formControlName="accountId" placeholder="Select " class="field-input filled">
            <ng-option *ngFor="let item of componentList" [value]="item.value">{{item.name}}</ng-option>
        </ng-select>
        </div>
    </div>
  </div>
  <div class="btn-block">
  <!-- <button class="btn btn-primary">↓ Export</button> -->
  <button class="btn btn-primary" (click)="addComponentPopUp(truckDetails)">+ Add Component</button>
  <button class="btn btn-primary" (click)="removeComponentPopUp(truckDetails)">— Remove Component</button>
  <button class="btn btn-primary" (click)="exchangeComponentPopUp(truckDetails)">⇄ Exchange Component</button>
  </div>
</div>

<!-- Table Card -->
<div class="table-card">
  <!-- <div class="table-toolbar">
    <div class="table-info">Showing 8 of 8 records for HR98M3252</div>
    <div class="status-toggle">
      Status:
      <div class="toggle-group">
        <button class="toggle-btn">All</button>
        <button class="toggle-btn active-live"><span class="toggle-dot live-dot"></span>Live</button>
        <button class="toggle-btn active-past"><span class="toggle-dot past-dot"></span>Past</button>
      </div>
    </div>
  </div> -->

  <table>
    <thead>
      <tr>
        <th>#</th>
        <th  (click)="sortData('truckNumber')">Truck No. <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('componentType')">Component Type  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('serialNumber')">Serial Number  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('fromDate')">From (Date)  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('kmAtAssociation')">KM at Association  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('toDate')">To (Date)  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('kmAtDisassociation')">KM at Disassociation  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('kmAtDisassociation')">KM Run on Truck  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th  (click)="sortData('status')">Running Status  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
        <th>Tyre Position</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let com of truckTranscations; let i = index">
        <td class="row-num">{{ i + 1 }}</td>
        <td><a class="truck-link">{{truckDetails?.truckNumber}}</a></td>
        <td><span class="comp-badge badge-tyre"><span class="comp-dot"></span>{{com?.componentType}}</span></td>
        <td class="serial">{{com?.serialNumber}}</td>
        <td class="">{{com?.createdAt | CustomDatePipe: 'D-M-YYYY'}}</td>
        <td class="km-val">{{com?.kmAtAssociation}}<span class="km-unit" *ngIf="com?.kmAtAssociation"> km</span></td>
        <td class="">
             <span *ngIf="com?.toDate; else activeTpl">
                {{ com?.toDate | CustomDatePipe:'D-M-YYYY' }}
            </span>

            <ng-template #activeTpl>
                <span class="dash-muted"></span>
            </ng-template>

            <span class="active-text" *ngIf="com?.status === 'Live'">Active</span>
            <!-- <span class="past-text" *ngIf="com?.status === 'Past'">Past</span> -->
        </td>
        <td>
            <span *ngIf="com?.kmAtDisassociation != null; else runningTpl">
                <span class="km-val">{{ com?.kmAtDisassociation }}</span>
                <span class="km-unit"> km</span>
            </span>

            <ng-template #runningTpl>
                <span class="dash-muted"></span>
            </ng-template>

            <span class="running-text" *ngIf="com?.status === 'Live'">Running</span>
            <!-- <span class="stopped-text" *ngIf="com?.status === 'Past'">Stopped</span> -->
        </td>
        <td>
          <div class="km-run-cell" *ngIf="com?.kmAtDisassociation != null && com?.kmAtAssociation != null">
            <span class="km-val">
                {{ (com?.kmAtDisassociation >= 0 && com?.kmAtAssociation >= 0)
                    ? (com.kmAtDisassociation - com.kmAtAssociation)
                    : '0' }}
                <!-- {{ (com?.kmAtDisassociation || 0) - (com?.kmAtAssociation || 0) }} -->
            </span> 
            <span class="km-unit" *ngIf="com?.kmAtDisassociation != null && com?.kmAtAssociation != null"> km</span>
            <!-- <div class="km-bar-wrap" *ngIf="com?.kmAtDisassociation && com?.kmAtAssociation"> <div class="km-bar-fill full" style="width:20%"></div></div> -->
          </div>
        </td>
        <!-- <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td> -->

        <td><span class="status-badge " [ngClass]="com?.status == 'Live' ? 'status-live':'status-past' " >
            <span class="" [ngClass]="com?.status == 'Live' ? 'status-live-dot':'status-past-dot' "></span>{{com?.status}}</span></td>
        <td>
            {{ com?.axelPosition }} &nbsp; {{com?.sideSlot}}
        </td>    
      </tr>
      <tr>
        <td colspan="7" *ngIf="truckTranscations?.length == 0">
            <span style="color: red;">Data Not Found</span>
        </td>
      </tr>
      <!-- <tr>
        <td class="row-num">02</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-tyre"><span class="comp-dot"></span>Tyre</span></td>
        <td class="serial">2131232</td>
        <td>21/01/2025</td>
        <td><span class="km-val">1,000</span><span class="km-unit">km</span></td>
        <td><span class="dash-muted">—</span> <span class="active-text">Active</span></td>
        <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val" style="color:var(--blue)">1,032</span><span class="km-unit">km</span>
            <span class="km-up">↑</span>
            <div class="km-bar-wrap"><div class="km-bar-fill" style="width:85%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-live"><span class=""></span>Live</span></td>
      </tr>
      <tr>
        <td class="row-num">03</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-tyre"><span class="comp-dot"></span>Tyre</span></td>
        <td class="serial">1232232</td>
        <td>21/01/2025</td>
        <td><span class="km-val">1,000</span><span class="km-unit">km</span></td>
        <td><span class="dash-muted">—</span> <span class="active-text">Active</span></td>
        <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val" style="color:var(--blue)">1,032</span><span class="km-unit">km</span>
            <span class="km-up">↑</span>
            <div class="km-bar-wrap"><div class="km-bar-fill" style="width:85%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-live"><span class="status-live-dot"></span>Live</span></td>
      </tr>
      <tr>
        <td class="row-num">04</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-battery"><span class="comp-dot"></span>Battery</span></td>
        <td class="serial">exd001</td>
        <td>21/01/2023</td>
        <td><span class="km-val">1,000</span><span class="km-unit">km</span></td>
        <td>20/12/2024</td>
        <td><span class="km-val">2,500</span><span class="km-unit">km</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val">1,500</span><span class="km-unit">km</span>
            <div class="km-bar-wrap"><div class="km-bar-fill full" style="width:100%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-past"><span class="status-past-dot"></span>Past</span></td>
      </tr>
      <tr>
        <td class="row-num">05</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-battery"><span class="comp-dot"></span>Battery</span></td>
        <td class="serial">exd002</td>
        <td>20/12/2024</td>
        <td><span class="km-val">2,032</span><span class="km-unit">km</span></td>
        <td><span class="dash-muted">—</span> <span class="active-text">Active</span></td>
        <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val">0</span><span class="km-unit">km</span>
            <span class="km-up">↑</span>
            <div class="km-bar-wrap"><div class="km-bar-fill" style="width:2%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-live"><span class="status-live-dot"></span>Live</span></td>
      </tr>
      <tr>
        <td class="row-num">06</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-insurance"><span class="comp-dot"></span>Insurance</span></td>
        <td class="serial">AIG001</td>
        <td>20/12/2024</td>
        <td><span class="km-val">2,032</span><span class="km-unit">km</span></td>
        <td><span class="dash-muted">—</span> <span class="active-text">Active</span></td>
        <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val">0</span><span class="km-unit">km</span>
            <span class="km-up">↑</span>
            <div class="km-bar-wrap"><div class="km-bar-fill" style="width:2%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-live"><span class="status-live-dot"></span>Live</span></td>
      </tr>
      <tr>
        <td class="row-num">07</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-pollution"><span class="comp-dot"></span>Pollution (PUC)</span></td>
        <td class="serial">HR001</td>
        <td>20/12/2024</td>
        <td><span class="km-val">2,032</span><span class="km-unit">km</span></td>
        <td><span class="dash-muted">—</span> <span class="active-text">Active</span></td>
        <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val">0</span><span class="km-unit">km</span>
            <span class="km-up">↑</span>
            <div class="km-bar-wrap"><div class="km-bar-fill" style="width:2%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-live"><span class="status-live-dot"></span>Live</span></td>
      </tr> -->
      <!-- <tr>
        <td class="row-num">08</td>
        <td><a href="#" class="truck-link">HR98M3252</a></td>
        <td><span class="comp-badge badge-repair"><span class="comp-dot"></span>Repair &amp; Maint.</span></td>
        <td class="serial">RP001</td>
        <td>20/12/2024</td>
        <td><span class="km-val">2,032</span><span class="km-unit">km</span></td>
        <td><span class="dash-muted">—</span> <span class="active-text">Active</span></td>
        <td><span class="dash-muted">—</span> <span class="running-text">Running</span></td>
        <td>
          <div class="km-run-cell">
            <span class="km-val">0</span><span class="km-unit">km</span>
            <span class="km-up">↑</span>
            <div class="km-bar-wrap"><div class="km-bar-fill" style="width:2%"></div></div>
          </div>
        </td>
        <td><span class="status-badge status-live"><span class="status-live-dot"></span>Live</span></td>
      </tr> -->
    </tbody>
  </table>

  <!-- <div class="table-footer">
    <div class="footer-info">Showing 1–8 of 8 records</div>
    <div class="pagination">
      <button class="page-btn">‹</button>
      <button class="page-btn active">1</button>
      <button class="page-btn">›</button>
    </div>
  </div> -->
</div>




<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']" style="display: none;">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Truck Details</h4>

                    </div>
                    <div class="d-flex">
                        <div class="tabs">
                            <a routerLink="/truck-mapping" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }">All Orders</a>
                            <a routerLink="/orders/draft-order" routerLinkActive="active">Draft Order</a>
                        </div>
                        <a *ngIf="accessControlService.canWrite('Common Upload')" class="btn btn-primary btn-sm ms-3"
                            (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Order</a>
                        <!-- *ngIf="accessControlService.canWrite('Budget')" -->
                        <button class="btn btn-primary btn-sm ms-3" (click)="addBudget('Add')"
                            *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">+ Assemble New Truck</button>
                        <div class="col" style="padding-left: 0;">
                            <app-export-btn [selectedRows]="selectedRows" [allColumns]="columns" [fileName]="'Orders'"
                                [exportApi]="getListExportApi"
                                [exportParams]="{ filters: filters, sortingCol: sortingCol, direction: direction }"></app-export-btn>
                        </div>
                    </div>
                </div>
                <!-- STAT CARDS -->
                <div class="stats-row">
                    <div class="stat-card">
                        <div class="stat-icon si-blue">🚛</div>
                        <div>
                            <div class="stat-label">Total Trucks</div>
                            <div class="stat-num">142</div>
                            <div class="stat-sub">All statuses</div>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon si-green">✅</div>
                        <div>
                            <div class="stat-label">Live Trucks</div>
                            <div class="stat-num">118</div>
                            <div class="stat-sub">Fully assembled &amp; submitted</div>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon si-orange">📋</div>
                        <div>
                            <div class="stat-label">Drafts</div>
                            <div class="stat-num">24</div>
                            <div class="stat-sub">Pending completion</div>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon si-yellow">⚠️</div>
                        <div>
                            <div class="stat-label">Compliance Alerts</div>
                            <div class="stat-num">9</div>
                            <div class="stat-sub">Expiring within 30 days</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <app-filter (filterChange)="onFilterChange($event)" [orderNumber]="true" [orderStatus]="true" [DateofPlacement]="true" [showCustomer]="true" [showVendor]="false"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <ng-container *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">
                                <ng-container *ngIf="selectedData[0]?.status == 'Draft' || selectedData[0]?.status == 'Created'">
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedData?.length ?? 0) > 0" (click)="editEvent()">Edit</a>
                                </ng-container>
                                </ng-container>
                                <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a>
                            </div>

                        </div>

                        <app-shared-table [componentName]="'orders'" [columns]="columns" [tableName]="tableName" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)" (reloadEvent)="reloadEvent($event)">
                        </app-shared-table>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div> -->


                <!-- TOP BAR -->
                <!-- <div class="topbar">
        <div class="topbar-left">
            <h1>Truck Fleet</h1>
            <p>View, manage and assemble all trucks in your fleet.</p>
        </div>
        <div class="topbar-right">
            <button class="btn btn-outline">↓ Export</button>
            <button class="btn btn-primary">+ Assemble New Truck</button>
        </div>
        </div> -->
                <div class="card">
                    <div class="card-body">


                        <!-- FILTER BAR -->
                        <!-- <div class="filter-bar">
        <div class="filter-left">
            <button class="tab-btn active-live" onclick="setTab(this,'live')">
            <span class="tab-live-dot"></span> Live Trucks <span class="tab-count">118</span>
            </button>
            <button class="tab-btn" onclick="setTab(this,'draft')">
            <span class="tab-draft-icon">📋</span> Draft Trucks <span class="tab-count">24</span>
            </button>
        </div>
        <div class="filter-right">
            <div class="search-box">
            <span class="search-icon">🔍</span>
            <input type="text" placeholder="Search truck, model, dealer…" />
            </div>
            <button class="btn btn-outline btn-sm">⚙ Filters</button>
            <button class="btn btn-outline btn-sm">↕ Sort</button>
        </div>
        </div> -->

                        <!-- BULK ACTION BAR -->
                        <div class="bulk-bar" id="bulkBar">
                            <app-filter (filterChange)="onFilterChange($event)" [orderNumber]="true"
                                [orderStatus]="true" [DateofPlacement]="true" [showCustomer]="true" [showVendor]="false"
                                (resetFilters)="onResetFilters()">
                            </app-filter>

                            <!-- <span class="bulk-selected">2 selected</span>
        <span class="bulk-label">Bulk actions:</span> -->
                            <div class="bulk-actions">
                                <button class="btn btn-primary btn-sm">+ Add Component</button>
                                <button class="btn btn-primary btn-sm">— Remove Component</button>
                                <button class="btn btn-primary btn-sm">⇄ Exchange Component</button>
                            </div>
                            <!-- <span class="bulk-close" onclick="document.getElementById('bulkBar').style.display='none'">✕</span> -->
                        </div>



                        <!-- TABLE -->
                        <div class="table-wrap">
                            <!-- <div class="table-toolbar">
            <div class="table-info-text">Showing 1–6 of 118 live trucks</div>
            <div class="filter-chips">
            <div class="fchip active"><span class="fchip-dot" style="background:#2563eb"></span> All</div>
            <div class="fchip">⚠ Compliance Alert</div>
            <div class="fchip"><span class="fchip-dot" style="background:#424242"></span> Tyre Gap</div>
            <div class="fchip"> ⚡ Battery Gap</div>
            </div>
        </div> -->


                            <table>
                                <thead>
                                    <!-- <tr>
                <th style="width:32px"><input type="checkbox" class="cb" /></th>
                <th colspan="3">TRUCK DETAILS</th>
                <th colspan="2">COMPONENTS</th>
                <th colspan="2">COMPLIANCE</th>
                <th colspan="2">DEALER</th>
                <th colspan="2">DATES</th>
                <th colspan="2">COMPONENT EVENT HISTORY</th>
            </tr> -->
                                    <tr>
                                        <th></th>
                                        <th>TRUCK NO. <span class="sort-i">⇅</span></th>
                                        <th>BRAND &amp; MODEL <span class="sort-i">⇅</span></th>
                                        <th>TYPE</th>
                                        <th>TYRES</th>
                                        <th>BATTERIES</th>
                                        <th>PUC</th>
                                        <th>INSURANCE</th>
                                        <th colspan="">DEALER <span class="sort-i">⇅</span></th>
                                        <th>ASSEMBLY DATE <span class="sort-i">⇅</span></th>
                                        <th>LAST MODIFIED <span class="sort-i">⇅</span></th>
                                        <th colspan="2">COMPONENT ADDED / REMOVED – KM READING <span
                                                class="sort-i">⇅</span></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <!-- ROW 1 — selected -->
                                    <tr class="">
                                        <td><input type="checkbox" class="cb" /></td>
                                        <td><a class="truck-link">TRK-2024-1042</a></td>
                                        <td>
                                            <div class="brand-name">TATA Prima 3525.K</div>
                                        </td>
                                        <td><span class="type-tag">32 FT MXL2</span></td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>12/12</span>
                                        </td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                                        <td><span class="comp-date cd-ok">✓ 14 Dec 2024</span></td>
                                        <td><span class="comp-date cd-warn">⚡ 28 Feb 2024</span></td>
                                        <td class="dealer-name">Sharma Motors<div class="dealer-code">DLR-0041</div>
                                        </td>

                                        <td>
                                            <div class="date-val">12 Jan 2024</div>
                                        </td>
                                        <td>
                                            <div class="date-val">02 Feb 2024</div>
                                        </td>
                                        <td colspan="2" class="event-list-main">
                                            <div class="event-list">
                                                <!-- <div class="event-item ev-added">
                    <div class="ev-badge">+ ADDED · <span class="ev-serial">SN-2312</span></div>
                    <div class="ev-meta">⬤ Tyre · 12 Jan 2024<br>KM Reading: 0 km</div>
                    </div> -->
                                                <div class="event-item ev-removed">
                                                    <div class="ev-badge">− REMOVED · <span
                                                            class="ev-serial">SN-1021</span></div>
                                                    <div class="ev-meta">⬤ Tyre · 28 Jan 2024<br>KM Reading: 4,220 km
                                                    </div>
                                                </div>
                                                <div class="ev-more">+ 3 more events →</div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- ROW 2 — selected -->
                                    <tr class="">
                                        <td><input type="checkbox" class="cb" /></td>
                                        <td><a class="truck-link">TRK-2024-1031</a></td>
                                        <td>
                                            <div class="brand-name">Ashok Leyland 3518</div>
                                        </td>
                                        <td><span class="type-tag">32 FT SKL</span></td>
                                        <td><span class="comp-pill cp-orange"><span class="cp-dot"></span>10/12</span>
                                        </td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                                        <td><span class="comp-date cd-ok">✓ 20 Nov 2024</span></td>
                                        <td><span class="comp-date cd-ok">✓ 10 Dec 2024</span></td>
                                        <td class="dealer-name">Kapoor Trucks<div class="dealer-code">DLR-0041</div>
                                        </td>

                                        <td>
                                            <div class="date-val">05 Jan 2024</div>
                                        </td>
                                        <td>
                                            <div class="date-val">28 Jan 2024</div>
                                        </td>
                                        <td colspan="2" class="event-list-main">
                                            <div class="event-list">
                                                <div class="event-item ev-exchanged">
                                                    <div class="ev-badge">⇄ EXCHANGED · <span
                                                            class="ev-serial">BAT-8841</span></div>
                                                    <div class="ev-meta">⚡ Battery · 15 Jan 2024<br>KM Reading: 1,800 km
                                                    </div>
                                                </div>
                                                <div class="ev-more">+ 1 more event →</div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- ROW 3 -->
                                    <tr>
                                        <td><input type="checkbox" class="cb" /></td>
                                        <td><a class="truck-link">TRK-2024-0998</a></td>
                                        <td>
                                            <div class="brand-name">TATA Prima 4028.S</div>
                                        </td>
                                        <td><span class="type-tag">40 FT HXL</span></td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>12/12</span>
                                        </td>
                                        <td><span class="comp-pill cp-orange"><span class="cp-dot"></span>1/2</span>
                                        </td>
                                        <td><span class="comp-expired">✕ Expired</span></td>
                                        <td><span class="comp-date cd-warn">⚡ 05 Mar 2024</span></td>
                                        <td class="dealer-name">Ravi Auto Works<div class="dealer-code">DLR-0041</div>
                                        </td>

                                        <td>
                                            <div class="date-val">18 Dec 2023</div>
                                        </td>
                                        <td>
                                            <div class="date-val">18 Dec 2023</div>
                                        </td>
                                        <td colspan="2" class="event-list-main">
                                            <div class="event-list">
                                                <div class="event-item ev-added">
                                                    <div class="ev-badge">+ ADDED · <span
                                                            class="ev-serial">SN-9910</span></div>
                                                    <div class="ev-meta">⬤ Tyre · 18 Dec 2023<br>KM Reading: 0 km</div>
                                                </div>
                                                <div class="ev-more">+ 2 more events →</div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- ROW 4 -->
                                    <tr>
                                        <td><input type="checkbox" class="cb" /></td>
                                        <td><a class="truck-link">TRK-2023-0871</a></td>
                                        <td>
                                            <div class="brand-name">Eicher Pro 6031</div>
                                        </td>
                                        <td><span class="type-tag">24 FT SKL</span></td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>8/8</span></td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                                        <td><span class="comp-date cd-ok">✓ 30 Sep 2024</span></td>
                                        <td><span class="comp-date cd-warn">⚡ 15 Mar 2024</span></td>
                                        <td class="dealer-name">Sharma Motors<div class="dealer-code">DLR-0041</div>
                                        </td>

                                        <td>
                                            <div class="date-val">02 Oct 2023</div>
                                        </td>
                                        <td>
                                            <div class="date-val">14 Jan 2024</div>
                                        </td>
                                        <td colspan="2" class="event-list-main">
                                            <div class="event-list">
                                                <div class="event-item ev-removed">
                                                    <div class="ev-badge">− REMOVED · <span
                                                            class="ev-serial">SN-6064</span></div>
                                                    <div class="ev-meta">⬤ Tyre · 14 Jan 2024<br>KM Reading: 22,400 km
                                                    </div>
                                                </div>
                                                <!-- <div class="event-item ev-added">
                    <div class="ev-badge">+ ADDED · <span class="ev-serial">SN-5521</span></div>
                    <div class="ev-meta">⬤ Tyre · 14 Jan 2024<br>KM Reading: 22,400 km</div>
                    </div> -->
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- ROW 5 -->
                                    <tr>
                                        <td><input type="checkbox" class="cb" /></td>
                                        <td><a class="truck-link">TRK-2023-0764</a></td>
                                        <td>
                                            <div class="brand-name">Mahindra Blazo X 40</div>
                                        </td>
                                        <td><span class="type-tag">40 FT MXL2</span></td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>12/12</span>
                                        </td>
                                        <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                                        <td><span class="comp-date cd-ok">✓ 12 Aug 2024</span></td>
                                        <td><span class="comp-date cd-ok">✓ 22 Oct 2024</span></td>
                                        <td class="dealer-name">National Fleet Co<div class="dealer-code">DLR-0041</div>
                                            .</td>

                                        <td>
                                            <div class="date-val">14 Jul 2023</div>
                                        </td>
                                        <td>
                                            <div class="date-val">14 Jul 2023</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="ev-none">No component changes since assembly</div>
                                        </td>
                                    </tr>

                                    <!-- ROW 6 — DRAFT -->
                                    <!-- <tr style="background:#fffbeb"> -->
                                    <tr>
                                        <td><input type="checkbox" class="cb" /></td>
                                        <td>
                                            <a class="truck-link">TRK-2024-1055</a>
                                            <span class="draft-tag">▶ DRAFT</span>
                                        </td>
                                        <td>
                                            <div class="brand-name">BharatBenz 3523R</div>
                                        </td>
                                        <td><span class="type-tag">32 FT SKL</span></td>
                                        <td><span class="comp-pill cp-orange"><span class="cp-dot"></span>4/12</span>
                                        </td>
                                        <td><span class="comp-pill cp-red"><span class="cp-dot"></span>0/2</span></td>
                                        <td><span class="comp-date cd-missing">— Not added</span></td>
                                        <td><span class="comp-date cd-missing">— Not added</span></td>
                                        <td class="dealer-name">—</td>

                                        <td>
                                            <div class="date-val">—</div>
                                        </td>
                                        <td>
                                            <div class="date-val">19 Feb 2024</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="draft-progress-wrap">
                                                <div class="dp-bar-track">
                                                    <div class="dp-bar-fill" style="width:40%"></div>
                                                </div>
                                                <div class="dp-label">40%</div>
                                            </div>
                                            <div class="dp-missing">Missing: Batteries, Compliance, Dealer</div>
                                            <button class="btn btn-outline btn-sm"
                                                style="width:100%;justify-content:center;border-color:#ea580c;color:#ea580c"
                                                onmouseover="this.style.background='#fff7ed'"
                                                onmouseout="this.style.background=''">▶ Resume Draft</button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <div class="table-footer">
                                <div class="footer-info">Showing 1–6 of 118 · 10 per page</div>
                                <div class="pagination">
                                    <button class="page-btn">‹</button>
                                    <button class="page-btn active">1</button>
                                    <button class="page-btn">2</button>
                                    <button class="page-btn">3</button>
                                    <button class="page-btn ellipsis">…</button>
                                    <button class="page-btn">12</button>
                                    <button class="page-btn">›</button>
                                </div>
                            </div>
                        </div>

                        <div style="height:24px"></div>








                    </div>
                </div>
            </div>
        </div>
    </div>
</div>        